export const getTextDirection = (content: string): 'ltr' | 'rtl' => {
  if (!content) return 'ltr';

  // 阿拉伯语字符范围
  const arabicRegex = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;
  // 英语字符范围（基本拉丁字母）
  const englishRegex = /[a-zA-Z]/;

  const hasArabic = arabicRegex.test(content);
  const hasEnglish = englishRegex.test(content);

  // 如果包含阿拉伯语且不包含英语，返回rtl
  if (hasArabic && !hasEnglish) {
    return 'rtl';
  }

  // 如果包含英语或都不包含，返回ltr
  return 'ltr';
}
